import { FeatureFlag } from '../FeatureFlag';

export const enableFeatureFlagDevTools = new FeatureFlag({
    key: 'enable-feature-flag-dev-tools',
    createdOn: '2026-01-30',
    defaultValue: false,
});
